import React from 'react'
import { Colors } from 'src/styles/DesignSystem'
import TitleSection from '../TitleSection'
import { EspecialidadeItem, EspecialidadesContainer, EspecialidadeWrapper } from './EspecialidadesStyles'

function Especialidades({ especialidades }) {

    return (
        <EspecialidadesContainer>
            <TitleSection textColor={Colors.brown}>Nossas especialidades</TitleSection>

            <EspecialidadeWrapper>
                {
                    especialidades.map((espec) => (
                        <EspecialidadeItem key={espec.id}>
                            <img src={espec.icon} alt={espec.title} />
                            <h2>{espec.title}</h2>
                        </EspecialidadeItem>
                    ))
                }                
            </EspecialidadeWrapper>
        </EspecialidadesContainer>
    )
}

export default Especialidades